<form [formGroup]="formFilter" (ngSubmit)="onSubmitFilterForm()">
    <div class="d-flex gap-1">
        <div class="col-md-2">
            <label><b>IMSI</b></label>
            <input
                type="text"
                placeholder="imsi"
                formControlName="imsi"
                pInputText
                [style]="{ minWidth: '100%' }"
            />
        </div>
        <div
            class="col-md"
            *ngIf="!(urlParamTypeDemand === OperationTransaction.SIM_BLANCHE)"
        >
            <label><b>MSISDN</b></label>
            <input
                type="text"
                placeholder="msisdn"
                formControlName="msisdn"
                pInputText
                [style]="{ minWidth: '100%' }"
            />
        </div>
        <div class="col-md">
            <label><b>Etape</b> </label>
            <p-dropdown
                emptyFilterMessage="Aucune correspondance"
                emptyMessage="Aucune donnée"
                [options]="listEtapeLigne"
                [showClear]="true"
                formControlName="statut"
                placeholder="Statut"
            >
                <ng-template let-data pTemplate="item">
                    <div class="country-item">
                        <div>{{ data | titlecase }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-md">
            <label><b>Etat</b> </label>
            <p-dropdown
                emptyFilterMessage="Aucune correspondance"
                emptyMessage="Aucune donnée"
                [options]="listEtatLigne"
                [filter]="true"
                filterBy="libele"
                [showClear]="true"
                formControlName="traitement"
                placeholder="Traitement"
                name="libele"
            >
                <ng-template let-data pTemplate="item">
                    <div class="country-item">
                        <div>{{ data | titlecase }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <div class="col-md-2">
            <label class="block"><b>Date début</b></label>
            <p-calendar
                formControlName="date_debut"
                [showIcon]="true"
                [placeholder]="'JJ-MM-AAAA'"
                dateFormat="dd-mm-yy"
            >
            </p-calendar>
        </div>
        <div class="col-md-2">
            <label class="block"><b>Date fin </b></label>
            <p-calendar
                formControlName="date_fin"
                [showIcon]="true"
                placeholder="JJ-MM-AAAA"
                dateFormat="dd-mm-yy"
            >
            </p-calendar>
        </div>

        <div class="filter-button">
            <button
                pButton
                pRipple
                type="submit"
                class="p-button-success"
                icon="pi pi-filter"
            ></button>
        </div>
    </div>
</form>
